import { connect } from 'react-redux';

import LearningAdminModuleCardShort from '../components/LearningAdminModuleCardShort';
import Format from '../../../../../lib/Format';
import {
  getImageSignedURL,
  setActiveImage,
} from '../../../../../state/modules/media/actions';

const mapStateToProps = (state, ownProps) => {
  const coverImage = ownProps.item?.cover_image ?? null;
  const sizeWidth = 329;
  const sizeHeight = 159;

  const imagePath = Format.buildImagePath(
    'ratio',
    sizeWidth,
    sizeHeight,
    coverImage
  );
  const imageUrl = state.media.getIn(['images', imagePath]) ?? null;

  return {
    imagePath: imagePath,
    imageUrl: imageUrl,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getSignedUrl: (path, cb) => {
      dispatch(getImageSignedURL(path, cb));
    },
    setActiveImage: (imageUrl, imagePath) => {
      dispatch(setActiveImage(imageUrl, imagePath));
    },
  };
};

const LearningAdminModuleCardShortContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(LearningAdminModuleCardShort);

export default LearningAdminModuleCardShortContainer;
